import { MOBILE_WIDTH } from "datastake-daf/src/constants/Style";
import styled from "styled-components";

const Style = styled.div`
  overflow-x: auto;

  @media(${MOBILE_WIDTH}) {
    flex-direction: column;
  }

  .row-item {
    flex: 1;
    padding-left: var(--size-lg);
    padding-right: var(--size-lg);
    border-right: 1px solid var(--border-color);

    @media(${MOBILE_WIDTH}) {
      border-bottom: 1px solid var(--border-color);
      border-right: 0px;
      padding: 0;
      padding-top: var(--size);
      padding-bottom: var(--size);

      &:first-of-type {
        padding-top: 0;
      }

      &:last-of-type {
        padding-bottom: 0;
        border-bottom: 0;
      }
    }

    min-width: 213px;

    &:first-of-type {
      padding-left: 0px;
    }

    &:last-of-type {
      padding-right: 0px;
      border-right: 0px;
    }

    h4 {
      font-size: 14px;
      font-weight: 500;
      color: var(--base-gray-80);
      margin-bottom: 8px;
    }

    span {
      font-size: 30px;
      font-weight: 600;
      color: var(--base-gray-90);
      margin-bottom: 0px;

      &.sm {
        font-size: 18px;
        margin-top: 14px;
      }
    }
  }
`;

export default Style;
